import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import { LifeArea } from 'shared/types/life-area';

import { getDefaultFilterDocument } from './get-default-filter-document';

export const getFilterDocument = (lifeArea?: LifeArea): FilterDocument => {
  const base = getDefaultFilterDocument(lifeArea);

  return {
    ...base,
    ...(lifeArea?.filterDocument ?? {}),
    showCompleted: !!lifeArea?.showCompletedTasks,
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(lifeArea?.filterDocument?.filters ?? {}),
      [FilterOptionKeys.LifeArea]: base.filters?.[FilterOptionKeys.LifeArea],
    },
  };
};
